export function toCsvValue(v) {
  if (v === null || v === undefined) return "";
  if (typeof v === "object") {
    try {
      return JSON.stringify(v);
    } catch {
      return String(v);
    }
  }
  return String(v);
}

export function downloadCsv(filename, rows) {
  const arr = Array.isArray(rows) ? rows : [];
  const keys = Array.from(
    arr.reduce((s, r) => {
      Object.keys(r || {}).forEach((k) => s.add(k));
      return s;
    }, new Set())
  );
  const header = keys.join(",");
  const lines = [header];
  for (const r of arr) {
    const line = keys.map((k) => {
        const raw = toCsvValue(r?.[k]);
        // escape
        const safe = raw.replace(/"/g, '""');
        return `"${safe}"`;
      }).join(",");
    lines.push(line);
  }
  const blob = new Blob([lines.join("\n")], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}

export function preferredColumnOrder(keys) {
  // Put common keys first.
  const priority = [
    "depositId",
    "type",
    "projectId",
    "projectName",
    "Survey Key",
    "Promotion Name",
    "poolKey",
    "reqKey",
    "account",
    "assetId",
    "claimedAt",
    "lastClaimSec",
    "claimCount",
    "amount",
    "tokenSymbol",
    "tokenContract",
    "actor",
  ];
  const p = new Map(priority.map((k, i) => [k, i]));
  return [...keys].sort((a, b) => {
    const pa = p.has(a) ? p.get(a) : 999;
    const pb = p.has(b) ? p.get(b) : 999;
    if (pa !== pb) return pa - pb;
    return String(a).localeCompare(String(b));
  });
}
